import React from "react";
import "./getstarted.scss";
import readingGlasses from "./readingGlasses.svg";
import { useState, useEffect } from "react";
import { db } from "../../firebase_setup/firebase";
import { doc, getDoc } from "firebase/firestore";

const GetStarted = () => {

  async function fetch() {
    const docSnap = await getDoc(docRef);
    if (docSnap) {
      setgetStarted(docSnap.data());
    }


    console.log(getStartedHeading["body"]);
  }

  const [getStartedHeading, setgetStarted] = useState({});
  const docRef = doc(db, "getStarted", "hjq8hy06mkAasKDVsSV1");
  useEffect(() => {
    fetch();
  });

  return (
    <div className="get-started-main" id="demo">
      <div className="get-started-about">
        <div className="heading">
          <h1>{getStartedHeading["heading"] ? getStartedHeading["heading"] : ""}</h1>
          <p className="special">
            {getStartedHeading["paras"] && getStartedHeading["paras"][0] ? getStartedHeading["paras"][0] : ""}
          </p>

          <p>
            {getStartedHeading["paras"] && getStartedHeading["paras"][1] ? getStartedHeading["paras"][1] : ""}
          </p>
          <p>
            {getStartedHeading["paras"] && getStartedHeading["paras"][2] ? getStartedHeading["paras"][2] : ""}
          </p>
          <p>
            {getStartedHeading["paras"] && getStartedHeading["paras"][3] ? getStartedHeading["paras"][3] : ""}
          </p>
          <p>
            {getStartedHeading["paras"] && getStartedHeading["paras"][4] ? getStartedHeading["paras"][4] : ""}
          </p>
        </div>
        <div className="get-started-for-free-button">
          <button className="button" onClick={()=>window.location.replace('https://play.google.com/store/apps/details?id=in.freshpage.android')}>Get Started for free</button>
        </div>
      </div>
      <div className="image-container">
        <img src={readingGlasses} alt="" />
      </div>
    </div>
  );
};

export default GetStarted;
